<template>
  <v-tooltip bottom :disabled="disabled">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" icon :small="small" color="primary" :disabled="disabled" @click="openInNewTab()">
        <v-icon size="18">mdi-open-in-new</v-icon>
      </v-btn>
    </template>
    <span v-text="$t('servicesystem.common_objects.document.open_in_new_tab')" />
  </v-tooltip>
</template>


<script>
export default {
  name: "OpenInNewTabBtn",
  props: {
    route: Object,
    small: {
      type: Boolean,
      default: true,
    }
  },

  data() {
    return {
    };
  },

  methods: {
    openInNewTab() {
      console.log(this.route, this.isCurrentRoute);
      if (!this.isCurrentRoute) {
        let newPageRoute = this.$router.resolve(this.route);
        window.open(newPageRoute.href, "_blank");
      }
    },
  },

  computed: {
    disabled() {
      return !this.route || this.isCurrentRoute;
    },

    isCurrentRoute() {
      return this.route && this.$route.name === this.route.name && JSON.stringify(this.$route.params) === JSON.stringify(this.route.params);
    },
  },

  watch: {},
};
</script>


<style lang="scss" scoped></style>